import { Meta } from "@/shared/components";
import { AssistantPlans } from "@/admin/features/assistantPlans";

export function AssistantPlansPage() {
  return (
    <>
      <Meta title="Планы помощника" />
      <AssistantPlans />
    </>
  );
}
